'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.dashboard').config(translationsConfig);

    function translationsConfig($translateProvider) {
        'ngInject';

        $translateProvider.translations('en-US', {
            'dashboard': {
                'Dashboard': 'Open data overview'
            }
        });
    }
})();